import { Image } from 'antd';
import { useNavigate } from 'react-router-dom';

interface OTPHeaderProps {
  logo: string;
  title: string;
  description: string| JSX.Element;
}

const OTPHeader: React.FC<OTPHeaderProps> = ({ logo, title, description }) => {
  const navigate = useNavigate();
  return (
    <>
      <Image preview={false} src={logo} width={250} onClick={() => navigate('/')} className='cursor-pointer' />
      <h1 className="text-base text-center font-medium mb-4 mt-4">{title}</h1>
      <p className="mb-8 w-full text-center mb-4 font-medium">{description}</p>
    </>
  );
};

export default OTPHeader;
